import { useState } from "react";
import { Gift, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import api from "../lib/api";

// Owner-only: email a friend this duck with a personal note; they land on the size chooser, pay and ship to themselves.
export const GiftDuckButton = ({ id, height, className = "" }) => {
  const [open, setOpen] = useState(false);
  const [to, setTo] = useState("");
  const [from, setFrom] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/creations/${id}/gift`, { to_email: to.trim(), from_name: from.trim(), note: note.trim(), height, public_base: window.location.origin });
      toast.success(`Gift sent to ${to.trim()} — they pick a size and the shop prints it.`);
      setOpen(false);
      setNote("");
      setTo("");
    } catch (err) {
      const code = err?.response?.status;
      toast.error(code === 404 ? "Only the maker of this duck can gift it (open it from the browser that made it)." : err?.response?.data?.detail || "Could not send the gift.");
    }
    setBusy(false);
  };

  return (
    <>
      <Button data-testid="gift-duck-btn" variant="outline" onClick={() => setOpen(true)} className={`rounded-full gap-2 h-11 ${className}`}>
        <Gift className="h-4 w-4" /> Gift this duck
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="gift-duck-dialog" className="rounded-3xl sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl">Gift this duck</DialogTitle>
            <DialogDescription>We email your friend the duck with your note and a link where they pick a size ({height} mm preselected), pay and enter their own address.</DialogDescription>
          </DialogHeader>
          <form onSubmit={send} className="space-y-3">
            <Input data-testid="gift-to-input" type="email" required placeholder="friend@example.com" value={to} onChange={(e) => setTo(e.target.value)} className="h-11 rounded-2xl" />
            <Input data-testid="gift-from-input" maxLength={60} placeholder="Your name (optional)" value={from} onChange={(e) => setFrom(e.target.value)} className="h-11 rounded-2xl" />
            <Textarea data-testid="gift-note-input" maxLength={300} placeholder="A personal note (optional, 300 characters)" value={note} onChange={(e) => setNote(e.target.value)} className="rounded-2xl min-h-24" />
            <Button data-testid="gift-send-btn" type="submit" disabled={busy || !to.trim()} className="w-full h-12 rounded-full font-bold gap-2">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Send the duck
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
